import angular from 'angular';

import CategoryMergeModalComponent from './category-merge-modal.cmpt';

export default angular
    .module('application.component.modals.component.category-merge-modal', [])
    .component(CategoryMergeModalComponent.selector, CategoryMergeModalComponent);




// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-merge-modal/index.js